import { X, Copy, Check } from 'lucide-react'
import { useState } from 'react'

export default function AiHelpModal({ isOpen, onClose, title, content, code }) {
  const [copied, setCopied] = useState(false)

  if (!isOpen) return null

  const handleCopy = () => {
    // Extract code from markdown if present
    const codeMatch = content.match(/```(?:javascript|js)?\n([\s\S]+?)\n```/)
    const textToCopy = codeMatch ? codeMatch[1] : content
    
    navigator.clipboard.writeText(textToCopy)
    setCopied(true)
    setTimeout(() => setCopied(false), 2000)
  }

  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center bg-black bg-opacity-50 p-8">
      <div className="bg-gray-900 rounded-lg shadow-2xl max-w-4xl w-full h-[85vh] flex flex-col border border-gray-700">
        {/* Fixed Header */}
        <div className="flex-shrink-0 flex items-center justify-between px-6 py-4 border-b border-gray-700">
          <h2 className="text-xl font-semibold text-white flex items-center gap-2">
            ✨ {title}
          </h2>
          <button
            onClick={onClose}
            className="text-gray-400 hover:text-white transition-colors p-1 hover:bg-gray-800 rounded"
          >
            <X size={20} />
          </button>
        </div>

        {/* Scrollable Content Area */}
        <div className="flex-1 overflow-y-auto min-h-0">
          {/* Original Code */}
          {code && (
            <div className="px-6 py-3 bg-gray-800 border-b border-gray-700 sticky top-0 z-10">
              <p className="text-xs text-gray-400 mb-2">Selected Code:</p>
              <pre className="text-sm text-gray-300 bg-gray-950 p-3 rounded overflow-x-auto max-h-32 overflow-y-auto">
                <code>{code}</code>
              </pre>
            </div>
          )}

          {/* AI Response Content */}
          <div className="px-6 py-4">
            <div className="prose prose-invert max-w-none">
              <div className="text-gray-200 whitespace-pre-wrap leading-relaxed">
                {content}
              </div>
            </div>
          </div>
        </div>

        {/* Fixed Footer Actions */}
        <div className="flex-shrink-0 flex items-center justify-end gap-3 px-6 py-4 border-t border-gray-700 bg-gray-800">
          <button
            onClick={handleCopy}
            className="flex items-center gap-2 px-4 py-2 bg-gray-700 hover:bg-gray-600 text-white rounded transition-colors"
          >
            {copied ? (
              <>
                <Check size={16} />
                Copied!
              </>
            ) : (
              <>
                <Copy size={16} />
                Copy Response
              </>
            )}
          </button>
          <button
            onClick={onClose}
            className="px-4 py-2 bg-p5-pink hover:bg-pink-600 text-white rounded transition-colors"
          >
            Close
          </button>
        </div>
      </div>
    </div>
  )
}
